// extracted by mini-css-extract-plugin
export default {"block":"otO2h","readOnlyBlock":"Fi0JN","caption":"xoFbU","captionLine":"KtJSJ"};